const { arrayOrStringPreparer } = require('../../tools/sql-tools')
const isArray = require('lodash/isArray')

// **
// Note: when adding new columns to route table
// ensure to refresh the view avocado.vw_route_with_program by running a new migration on it
// especially if the api relies on querying vw_route_with_program

const SHARED_ROUTE_COLUMNS = [
  'id',
  'couchdb_id',
  'couchdb_service_id',
  'name',
  'delivery_day',
  'delivery_frequency',
  'first_delivery_date',
  'count_day',
  'count_frequency',
  'first_count_date',
  'created_by',
  'created_at',
  'updated_by',
  'updated_at',
  'delivery_cycle_weeks',
  'count_cycle_weeks',
  'status',
  'start_date',
  'end_date',
  'approval_date',
  'estimated_delivery_date',
  'estimated_pickup_date',
  'carrier_id',
  'accepted',
  'external_id',
  'organisation_id'
]

const SHARED_VIRTUAL_COLUMNS = ['shipments']

const SHARED_GET_RELATED = {
  shipments: {
    relatedTable: 'avocado.data_shipment',
    pk: 'couchdb_id',
    fk: 'route_id'
  },
  carrier: {
    relatedTable: 'avocado.data_organisation',
    pk: 'carrier_id',
    fk: 'id'
  }
}

const SHARED_COLUMN_PREPARERS = {
  couchdb_id: arrayOrStringPreparer,
  start_date: (key, value) => [{ statement: `"${key}">=%INDEX%`, value }],
  end_date: (key, value) => [{ statement: `"${key}"<=%INDEX%`, value }],
  status: arrayOrStringPreparer,
  carrier_id: arrayOrStringPreparer
}

// arrayOrStringPreparer is not sufficient for program_ids because
// it incorrectly uses "${key}" = ANY(%INDEX%::TEXT[])" for arrays with multiple values.
// It should use "${key}" && %INDEX%::TEXT[]" to check for array overlap.
const arrayPreparer = (key, value) => {
  const arrayValue = isArray(value) ? value : [value]
  return [
    { statement: `"${key}" && %INDEX%::TEXT[]`, value: arrayValue }
  ]
}

module.exports = {
  SHARED_ROUTE_COLUMNS,
  SHARED_VIRTUAL_COLUMNS,
  SHARED_GET_RELATED,
  SHARED_COLUMN_PREPARERS,
  arrayPreparer
}
